import React from 'react';
import { useSelector } from 'react-redux';
import Avatar from 'components/Avatar';
import { VerifiedIcon } from 'components/Icons';
import { USER_PROFILE, PROFILE } from 'constants/routes';
import { Link } from 'react-router-dom';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import { useTranslation } from 'react-i18next';
import SubscribeComponent from '../SubscribeComponent';

const PostHeader = ({ post, showSubscribe = false }) => {
  const user = useSelector(selectAuthUser);
  const { t } = useTranslation();

  return (
    <div className="pb-2 d-flex align-items-center text-white">
      <Link
        className="d-flex align-items-center h5"
        to={USER_PROFILE.replace(':userId?', post.user.id).replace(
          ':name?',
          !!post.user.nickname ? post.user.nickname : ''
        )}
      >
        <Avatar
          style={{ fontSize: '15px' }}
          user={post.user.name}
          size={48}
          image={post.user.avatar}
          isOnline={post.user.is_online}
        />

        <div className="d-flex flex-column post-info">
          <div className="d-flex align-items-center">
          <p className="post-header-username font-weight-bold text-bold-gray post-author-name d-flex" style={{ marginLeft: '12px'}}>
            {post.user.name}
          
            {post.user.verification_status === "verified" && (

              <VerifiedIcon height="1rem" width="1rem" className="fill-grey ml-x header-icon-grey verified-icon-post-header" />
            )}
            </p>
            </div>

          <p
            className="text-light-gray post-author-nickname font-size-14"
            style={{ color: '#797f92', marginLeft: '12px' }}
          >
            @{post.user.nickname}
          </p>
        </div>
      </Link>

    </div>
  );
};

export default PostHeader;
